import Vue from 'vue'
import Vuex from 'vuex'
import venue from './venue'
import user from './user'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    venue,
    user
  },
  getters
})
